import { Box } from "@mui/material";
import ProgressContent from "./ProgressContent";
import { blueGrey } from "@mui/material/colors";

export interface IStepItem {
  title: string;
  date?: string;
  status?: "pending" | "done";
  index: number;
  description: string;
}

export default function GraphicalStatus() {
  const stepItems: IStepItem[] = [
    {
      title: "تایید حمل",
      status: "done",
      date: "1403/05/08",
      index: 1,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
    {
      title: "صدور مجوز",
      status: "done",
      date: "1403/05/08",
      index: 2,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
    {
      title: "صدور بارنامه",
      status: "done",
      date: "1403/05/08",
      index: 3,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
    {
      title: "در مسیر مقصد",
      status: "done",
      date: "1403/05/08",
      index: 3,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
    {
      title: "تخلیه در مقصد",
      status: "done",
      date: "1403/05/08",
      index: 4,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
  ];
  return (
    <Box
      sx={{
        mt: 1,
        width: "100%",
        borderRadius: "12px",

        border: "1px solid",
        borderColor: blueGrey[400],
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ProgressContent items={stepItems} />
    </Box>
  );
}
